import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { AddressSuggestionsSelectComponent } from '@sdvor/delivery/ui/v2';
import { Pos } from '@shop/const';
import { GeocodeResult } from '@yandex-maps/const';
import { BehaviorSubject, Observable } from 'rxjs';
import { ShopListComponent } from '../../../shop-list';

@Component({
  selector: 'sd-bottom-sheet-shop-list',
  imports: [AsyncPipe, AddressSuggestionsSelectComponent, ShopListComponent],
  templateUrl: './shop-list.component.html',
  styleUrls: ['./shop-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomSheetShopListComponent {
  readonly placeholder = 'поиск';
  isOpened = signal<boolean>(false);

  @Input() activeId$: BehaviorSubject<string>;
  @Input() shopsSorted$: Observable<Pos[]>;
  @Input() clickShop: (id: string, zoom?: number) => void;
  @Input() changeAddress: (geocodeResult?: GeocodeResult) => void;

  handleIsOpened(opened: boolean): void {
    this.isOpened.set(opened);
  }

  handleShopClick(id: string): void {
    this.clickShop(id);
  }

  handleAddressChange(address: GeocodeResult): void {
    this.changeAddress(address);
  }
}
